var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoStopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 459.557,
    height: 459.845,
    viewBox: "0 0 459.557 459.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "no-stopping",
    transform: "translate(-0.475 511.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M209.663-511.062c-44.442,4.318-85.466,20.692-121.451,48.4-17.543,13.495-40.3,38.864-53.438,59.556-5.668,8.906-16.733,31.577-20.692,42.373A279.612,279.612,0,0,0,2.567-315.841c-2.789,17.543-2.789,50.829,0,68.372a227.044,227.044,0,0,0,21.321,67.023c11.875,24.2,24.2,41.383,43.992,61.265,19.882,19.792,37.065,32.117,61.265,43.992a227.044,227.044,0,0,0,67.023,21.321c17.543,2.789,50.83,2.789,68.372,0a227.043,227.043,0,0,0,67.023-21.321c24.2-11.875,41.383-24.2,61.265-43.992,19.792-19.882,32.117-37.065,43.992-61.265,7.917-16.1,11.875-26.629,16.193-42.823,5.668-21.591,7.017-33.377,7.017-58.386s-1.349-36.8-7.017-58.386c-4.318-16.194-8.277-26.719-16.193-42.823-11.875-24.2-24.2-41.383-43.992-61.265-19.882-19.792-37.065-32.117-61.265-43.992a223.59,223.59,0,0,0-66.573-21.141C251.766-511.332,222.258-512.322,209.663-511.062Zm49.48,59.286c49.93,8.726,92.393,37.695,118.932,81.057,31.127,50.919,33.107,115.6,5.308,168.682-4.048,7.737-11.515,20.242-12.145,20.242-.09,0-54.248-54.158-120.461-120.371L130.405-422.538l5.218-3.509c16.913-11.245,39.224-20.422,60.1-24.83C214.341-454.745,240.071-455.1,259.143-451.776Zm-49.21,190.633L330.3-140.772l-5.218,3.509c-7.827,5.218-23.93,13.4-33.107,16.913a173.269,173.269,0,0,1-124.51-.63c-43.9-16.913-80.877-53.888-97.791-97.791-18.173-47.141-15.474-98.51,7.647-142.5,4.048-7.737,11.515-20.242,12.145-20.242C89.562-381.514,143.72-327.356,209.933-261.143Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoStopping);
export default __webpack_public_path__ + "static/media/no-stopping.23832acef75c364073b8e4e2e5e19380.svg";
export { ForwardRef as ReactComponent };